'use client'

import { useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'
import { recordView } from '@/lib/actions/analytics'

export function AnalyticsTracker() {
    const pathname = usePathname()
    const initialized = useRef(false)

    useEffect(() => {
        // Prevent double firing in React Strict Mode (dev only issue usually, but good practice)
        // Also helps if we want to debounce
        if (!initialized.current) {
            initialized.current = true
            recordView(pathname)
        } else {
            // If pathname changes, we want to record again. 
            // But initializing ref trick is for MOUNT only. 
            // Actually, for a pure client component inside layout, it mounts once.
            // But Next.js layouts preserve state on navigation. 
            // We need to track PATH changes.

        }
    }, [])

    // Better approach for Next.js app router:
    // This component will be mounted once in layout.
    // We need to listen to pathname changes.

    useEffect(() => {
        recordView(pathname)
    }, [pathname])

    return null
}
